import { Controller } from "@hotwired/stimulus";

const ACTIVE_CLASSES = ["text-blue-600", "dark:text-blue-400", "border-b-2", "border-blue-500"];
const INACTIVE_CLASSES = ["text-gray-500", "dark:text-gray-400"];

export default class extends Controller {
  static targets = ["tab"];

  connect() {
    this.#activate(this.#hasActionableUnread() ? "inbox" : "general");
  }

  showInbox() {
    this.#activate("inbox");
  }

  showGeneral() {
    this.#activate("general");
  }

  #activate(tabName) {
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tab === tabName;
      tab.classList.remove(...(isActive ? INACTIVE_CLASSES : ACTIVE_CLASSES));
      tab.classList.add(...(isActive ? ACTIVE_CLASSES : INACTIVE_CLASSES));
    });

    this.#items().forEach((item) => {
      const isActionable = item.dataset.actionable === "true";
      const visible = tabName === "inbox" ? isActionable : !isActionable;
      item.style.display = visible ? "" : "none";
    });
  }

  #hasActionableUnread() {
    return this.#items().some(
      (item) => item.dataset.actionable === "true" && item.dataset.read === "false"
    );
  }

  #items() {
    return Array.from(this.element.querySelectorAll("li[data-actionable]"));
  }
}
